import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { countries } from '../Country';
import { indianStates } from '../IndianStates';
//import { Link } from 'react-router-dom';
import { useLocation, useNavigate } from 'react-router-dom';
import CustomerContactEdit from './AdmissionContactEdit';
import { useSidebar } from '../../SidebarContext';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import normalizePhoneNumber from '../utils/normalizePhoneNumber';


const AddAdmission3 = () => {
    const { isSidebarOpen } = useSidebar();
    const [selectedType, setSelectedType] = useState('individual');
    const [activeTab, setActiveTab] = useState(1);
    const [isMoreDetailsOpen, setMoreDetailsOpen] = useState(false);

    const location = useLocation();
    const submittedData = location.state;
    const url = process.env.REACT_APP_LINK

    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
    const handleTabClick = (tabIndex) => setActiveTab(tabIndex);
    const toggleMoreDetails = () => setMoreDetailsOpen(!isMoreDetailsOpen);
    const [contactList, setContactList] = useState([]);

    const [formData, setFormData] = useState({
        name: "",
        fatherName: "",
        motherName: "",
        email: "",
        center: "",
        mobile: "",
        dob: "",
        aadhar: "",
        school: "",
        address: "INR",
        pincode: "",
        gender: "",
        department: "",
        designation: "",
        twitter: "",
        skype: "",
        facebook: "",
        main_id: isLoggedIn.main_id,

        sales_person: ""

    });

    console.log(formData)
    const [document, setDocument] = useState(null);
    const [documentPreview, setDocumentPreview] = useState('');
    const navigate = useNavigate();

    const formatToInputDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        if (isNaN(date)) return "";
        return date.toISOString().split("T")[0]; // ✅ gives "2025-07-25"
    };



    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setDocument(file);
            setDocumentPreview(URL.createObjectURL(file)); // Local preview
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === "phone1" || name === "phone2") {
            const normalized = normalizePhoneNumber(value);
            setFormData(prev => ({ ...prev, [name]: normalized }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }

    };

    const handleSelectChange = (selected, { name }) => {
        setFormData(prev => ({ ...prev, [name]: selected ? selected.value : "" }));
    };

    // const [billingAddress, setBillingAddress] = useState({
    //     attention: "",
    //     country: "",
    //     address: "",
    //     city: "",
    //     state: "",
    //     pincode: "",
    //     number: "",
    // });

    // const [shippingAddress, setShippingAddress] = useState({
    //     attention: "",
    //     country: "",
    //     address: "",
    //     city: "",
    //     state: "",
    //     pincode: "",
    //     number: "",
    // });

    const handleBillingChange = (e) => {
        const { name, value } = e.target;
        const processedValue = name === "number" ? normalizePhoneNumber(value) : value;
        setFormData(prev => ({
            ...prev,
            billingAddress: {
                ...prev.billingAddress,
                [name]: processedValue,
            }
        }));
    };

    const handleShippingChange = (e) => {
        const { name, value } = e.target;
        const processedValue = name === "number" ? normalizePhoneNumber(value) : value;

        setFormData(prev => ({
            ...prev,
            shippingAddress: {
                ...prev.shippingAddress,
                [name]: processedValue,
            }
        }));
    };

    const handleBillingSelectChange = (selected, { name }) => {
        setFormData(prev => ({
            ...prev,
            billingAddress: {
                ...prev.billingAddress,
                [name]: selected ? selected.value : "",
            }
        }));
    };

    const handleShippingSelectChange = (selected, { name }) => {
        setFormData(prev => ({
            ...prev,
            shippingAddress: {
                ...prev.shippingAddress,
                [name]: selected ? selected.value : "",
            }
        }));
    };


    const copyBillingToShipping = () => {
        setFormData(prev => ({
            ...prev,
            shippingAddress: { ...prev.billingAddress }
        }));
    };


    const currencyOptions = [
        { value: 'INR', label: 'INR' },
    ];

    useEffect(() => {
        if (submittedData) {
            console.log("✅ submittedData:", submittedData);
            console.log("✅ Formatted DOB:", formatToInputDate(submittedData.dob));

            setFormData(prev => ({
                ...prev,
                ...submittedData,
                dob: formatToInputDate(submittedData.dob),
                main_id: isLoggedIn?.main_id,
               
            }));
        }
    }, []);



    const handleSubmit = async (e) => {
        e.preventDefault();

        const formDataToSend = new FormData();

        // Convert address and contact to JSON strings



        const method = formData.id ? "PUT" : "POST";
        const urlmain = formData.id
            ? `${url}/admission/${formData.id}`
            : `${url}/admission/`;

        try {
            const res = await fetch(urlmain, {
                method,
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(formData),
            });

            const result = await res.json();
            if (res.ok) {
                alert(`Customer ${formData.id ? "updated" : "created"} successfully!`);
                navigate("/admission"); // Redirect to customer list or desired page
            } else {
                alert(result.error || "Failed to submit");
            }
        } catch (err) {
            console.error(err);
            alert("Error submitting form");
        }
    };



    // const handleDelete = async (customerId) => {
    //     console.log("Deleting customer with ID:", customerId); // 🔍 check if this is undefined

    //     const confirm = window.confirm('Are you sure you want to delete this customer?');
    //     if (!confirm) return;

    //     try {
    //       const response = await fetch(`http://192.168.1.47:5000/api/customers/${customerId}`, {
    //         method: 'DELETE',
    //       });

    //       if (!response.ok) {
    //         const err = await response.json();
    //         throw new Error(err?.message || 'Failed to delete');
    //       }

    //       alert('Customer deleted successfully!');
    //       // Optional: redirect to customer list or clear form
    //     } catch (error) {
    //       console.error('Delete error:', error.message);
    //       alert(`Error: ${error.message}`);
    //     }
    //   };
    console.log(formData);

    // useEffect(() => {
    //     if (submittedData) {
    //         setFormData(submittedData);

    //     }
    // }, [submittedData]);



    // console.log("Form Data:", JSON.stringify(formData, null, 2));

    return (
        <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
            <form className="oms-modal-form" onSubmit={handleSubmit}>
                {/* <div className="oms-form-group">
                    <label className="oms-form-label">Customer Type</label>
                    <div className="oms-form-radio">
                        <label
                            className={`radio-label ${selectedType === 'individual' ? 'checked' : ''}`}
                        >
                            <input
                                type="radio"
                                name="customerType"
                                value="individual"
                                checked={selectedType === 'individual'}
                                onChange={() => setSelectedType('individual')}
                            />
                            Individual
                        </label>
                        <label
                            className={`radio-label ${selectedType === 'company' ? 'checked' : ''}`}
                        >
                            <input
                                type="radio"
                                name="customerType"
                                value="company"
                                checked={selectedType === 'company'}
                                onChange={() => setSelectedType('company')}
                            />
                            Company
                        </label>
                    </div>
                </div> */}
                <div className="oms-form-flex">
                    <div className="oms-form-group">
                        <label htmlFor="name" className="oms-form-label">
                            Name
                        </label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={handleInputChange}
                            placeholder="Enter customer name"
                        />
                    </div>


                    <div className="oms-form-group">
                        <label htmlFor="fatherName" className="oms-form-label">
                            Father Name
                        </label>
                        <input type="text" id="fatherName"
                            name="fatherName"
                            value={formData.fatherName}
                            onChange={handleInputChange}
                            placeholder="Enter company name" />
                    </div>

                    <div className="oms-form-group">
                        <label htmlFor="motherName" className="oms-form-label">
                            Mother Name
                        </label>
                        <input type="text"
                            name="motherName"
                            value={formData.motherName}

                            onChange={handleInputChange}
                            placeholder="Enter display name" />
                    </div>

                    {/* <div className="oms-form-group">
                        <label htmlFor="currency" className="oms-form-label">
                            Currency
                        </label>
                        <Select
                            name="currency"
                            value={formData.currency ? { value: formData.currency, label: formData.currency } : null}
                            options={currencyOptions}
                            onChange={handleSelectChange}
                            isDisabled
                        />
                    </div> */}
                    <div className="oms-form-group">
                        <label htmlFor="email" className="oms-form-label">
                            Email
                        </label>
                        <input type="email" id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                            placeholder="Enter email" />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="center" className="oms-form-label">
                            Center
                        </label>

                        <select name="center" id="center" value={formData.center}
                            onChange={handleInputChange}>
                            <option value="">Select</option>
                            <option value="Airoli">Airoli</option>
                            <option value="Kandivali">Kandivali</option>
                            <option value="Naigaon">Naigaon</option>
                            <option value="Ghansoli">Ghansoli</option>
                            <option value="Goregoan West">Goregoan West</option>
                        </select>
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="mobile" className="oms-form-label">
                            Phone Number
                        </label>
                        <input type="tel" id="mobile"
                            name="mobile"
                            value={formData.mobile}
                            onChange={handleInputChange}
                            onKeyPress={(e) => {
                                if (!/[0-9]/.test(e.key)) {
                                    e.preventDefault(); // Prevent non-numeric characters
                                }
                            }}
                            placeholder="Enter phone number 1" />
                    </div>

                    <div className="oms-form-group">
                        <label htmlFor="dob" className="oms-form-label">
                            Date of Birth
                        </label>
                        <input
                            type="date"
                            id="dob"
                            name="dob"
                            value={formData.dob || ""}
                            onChange={handleInputChange}
                        />

                    </div>

                    <div className="oms-form-group">
                        <label htmlFor="aadhar" className="oms-form-label">
                            Aadhar
                        </label>
                        <input type="text" id="aadhar"
                            name="aadhar"
                            value={formData.aadhar}
                            onChange={handleInputChange}
                            placeholder="Enter aadhar" />
                    </div>
                    {/* <div className="oms-form-group">
                        <label htmlFor="gender" className="oms-form-label">
                            Gender
                        </label>
                        <input type="text" id="gender"
                            name="gender"
                            value={formData.gender}
                            onChange={handleInputChange}
                            placeholder="Enter Gender" />
                    </div> */}
                    <div className="oms-form-group">
                        <label htmlFor="school" className="oms-form-label">
                            School
                        </label>
                        <input type="text" id="school"
                            name="school"
                            value={formData.school}
                            onChange={handleInputChange}
                            placeholder="Enter school" />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="address" className="oms-form-label">
                            Address
                        </label>
                        <input type="text" id="address"
                            name="address"
                            value={formData.address}
                            onChange={handleInputChange}
                            placeholder="Enter address" />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="pincode" className="oms-form-label">
                            Pincode
                        </label>
                        <input type="text" id="pincode"
                            name="pincode"
                            value={formData.pincode}
                            onChange={handleInputChange}
                            placeholder="Enter pincode" />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="gender" className="oms-form-label">
                            Gender
                        </label>
                        {/* <input type="text" id="pincode"
                            name="pincode"
                            value={formData.pincode}
                            onChange={handleInputChange}
                            placeholder="Enter pincode" /> */}
                        <select name="gender" id="gender" value={formData.gender}
                            onChange={handleInputChange}>
                            <option value="">Select</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                            <option value="Transgender">Transgender</option>
                        </select>
                    </div>
                </div>


                {/* Tabs */}




                <div className="oms-form-actions">

                    {/* //<Link to="/add-customer2">
          <button type="button">Back</button>
       {/* </Link>
                <button type="button" onClick={() => handleDelete(formData.id)}>Delete</button> */}

                    <button type="submit"
                    >Update</button>
                </div>
            </form>
        </div >
    );
};

export default AddAdmission3;
